import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'cdp-event-management-configurations',
  templateUrl: './segmentation-members.component.html',
  styleUrls: ['./segmentation-members.component.scss']
})
export class SegmentationMembersComponent implements OnInit {
  constructor(
    private router: Router,
    private rout: ActivatedRoute,
    private titleService: Title,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('Segmentation Members Grid')
    );
    this.router.navigate(
      ["segmentation-members/grid"],
      {
        relativeTo: this.rout.parent,
        queryParamsHandling: 'preserve',
      }
    );
  }
}
